module.exports = __webpack_public_path__ + "static/p2-a9ad9e921119502d0cd7abdcbe51d215.jpg";